// extracted by mini-css-extract-plugin
export default {"container":"styles_container__B5h32","loadingWrapper":"styles_loadingWrapper__KYVWr"};